import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Terms: React.FC = () => {
  const { surfaceClass } = useTheme();

  return (
    <div className="pb-24 px-6 pt-6 max-w-3xl mx-auto animate-in slide-in-from-bottom-4 duration-500">
      
      <Link to="/" className="inline-flex items-center gap-2 opacity-50 hover:opacity-100 mb-8 transition-opacity">
          <ChevronLeft size={20} /> Back to Home
      </Link>

      <div className={`p-8 rounded-2xl border border-black/5 dark:border-white/5 shadow-sm ${surfaceClass}`}>
        <h1 className="font-serif text-3xl font-bold mb-2">Terms of Service</h1>
        <p className="opacity-50 text-sm mb-8">Last updated: March 15, 2024</p>

        <div className="prose dark:prose-invert max-w-none text-sm leading-relaxed opacity-80 space-y-6">
            <p>
                Welcome to <strong>Readsy.link</strong> ("Readsy", "we", "us", or "our"). By accessing or using our website and services, you agree to be bound by these Terms of Service.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">1. Use of Service</h3>
            <p>
                Readsy provides a digital reading platform. You may use our service for personal, non-commercial use only. You agree not to copy, distribute, or modify any content found on Readsy without express permission.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">2. User Accounts</h3>
            <p>
                To access certain features, you must create an account via our Magic Link authentication. You are responsible for maintaining the security of your email account. Readsy is not liable for any loss or damage arising from unauthorized access to your email.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">3. Content and Copyright</h3>
            <p>
                The books and content available on Readsy are either public domain, licensed, or user-submitted. 
                <strong>For Authors:</strong> By submitting content, you grant Readsy a license to display and distribute your work on our platform. You retain ownership of your copyright.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">4. Acceptable Use</h3>
            <p>
                You agree not to use Readsy to:
                <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Violate any laws or regulations.</li>
                    <li>Infringe upon the rights of others.</li>
                    <li>Distribute malware or harmful code.</li>
                    <li>Attempt to reverse engineer our platform.</li>
                </ul>
            </p>

            <h3 className="font-bold text-lg text-brand-blue">5. Termination</h3>
            <p>
                We reserve the right to suspend or terminate your access to Readsy at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">6. Changes to Terms</h3>
            <p>
                We may modify these Terms at any time. If we make material changes, we will notify you by posting the revised Terms on our website. Your continued use of Readsy after such changes constitutes your acceptance of the new Terms.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">7. Contact</h3>
            <p>
                If you have any questions about these Terms, please contact us at <a href="mailto:hello@readsy.link" className="text-brand-blue underline">hello@readsy.link</a>.
            </p>
        </div>
      </div>
    </div>
  );
};